import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import { Splide } from '@splidejs/splide'

const app = Application.start()

app.register('refosumu--home-index--contract-ranking--component', class extends Controller {
  static targets = ['sliderPc']

  connect() {
    this.initializeSlider()
  }

  initializeSlider() {
    const PC_PER_PAGE = 4

    // PC用スライダー初期化
    if (this.hasSliderPcTarget) {
      const pcSlides = this.sliderPcTarget.querySelectorAll('.splide__slide')
      const pcSlideCount = pcSlides.length

      const pcConfig = {
        speed: 800,
        perPage: PC_PER_PAGE,
        perMove: PC_PER_PAGE,
        gap: '0',
        pagination: false,
        arrows: pcSlideCount > PC_PER_PAGE,
        autoWidth: true
      }

      const pcSplide = new Splide(this.sliderPcTarget, pcConfig)
      pcSplide.mount()
    }
  }
})
